import * as z from 'zod';

// Types
import { blocksSchemaZod } from '@/components/blocks/Blocks';
import { SeoZod } from '@/types/SeoType';

export const ExpertiseZod = z.object({
  id: z.number(),
  documentId: z.string(),
  slug: z.string(),
  blocks: z.array(blocksSchemaZod),
  seo: SeoZod,
});

export type ExpertiseType = z.infer<typeof ExpertiseZod>;

export const ExpertiseSlugZod = ExpertiseZod.pick({
  id: true,
  documentId: true,
  slug: true,
  seo: true,
});

export type ExpertiseSlugType = z.infer<typeof ExpertiseSlugZod>;
